import { render, Component } from 'preact';
import FavoritesProvider from './app/contexts/FavoritesContext';
import EncyclopediaIndex from './app/encyclopedia/EncyclopediaIndex';

class Encyclopedia extends Component {
	render() {
		return (
			<FavoritesProvider>
				<EncyclopediaIndex />
			</FavoritesProvider>
		);
	}
}

window.addEventListener(
	'load',
	function() {
		const app = document.getElementById('app-encyclopedia');

		if (typeof app != 'undefined' && app != null) {
			render(<Encyclopedia />, app);
		}
	},
	false
);
